<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
})

type BlockEntryProps = {
  fields: any
  sys: any
  componentName: string
}

const props = defineProps<BlockEntryProps>()
const variant = props.fields?.supportingData?.['home']?.variant?.value || 'unknown'

const data = ['picture', 'video', 'icon'].includes(props.componentName)
  ? { fields: props.fields, sys: props.sys }
  : { ...props.fields, componentName: props.componentName, variant }
const preset = props.componentName === 'picture' ? 'grid' : null /* Richtext>Picture max-width == --content-width */

const currentComponent = computed(() => {
  switch (props.componentName) {
    case 'cardPanel':
      return resolveComponent('CardPanelSwitcher')
    case 'icon':
    case 'picture':
    case 'video':
      return resolveComponent('Media')
    case 'link':
      return resolveComponent('Action')
    case 'productCarousel':
      return resolveComponent('ProductCarousel')
    case 'table':
      return resolveComponent('Table')
    default:
      return null
  }
})
</script>

<template>
  <component class="rich-text__block-entry" :is="currentComponent" v-bind="data" :preset="preset" />
</template>

<style lang="postcss">
.rich-text__block-entry {
  margin: var(--space-70) auto;

  &.icon {
    display: block; /* reset inline-block */
  }
  &.action {
    display: flex; /* reset inline-flex */
  }
}
</style>
